import { render, staticRenderFns } from "./EmployerCard.vue?vue&type=template&id=7243c916&"
import script from "./EmployerCard.vue?vue&type=script&lang=js&"
export * from "./EmployerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports